export enum KpiTypeTrendStackChart {
  MARKET_REVENUE = 'Market Revenue',
  MARKET_UNITS = 'Market Units',
  RETAILER_REVENUE = 'Retailer Revenue',
  RETAILER_UNITS = 'Retailer Units',
}

export enum SalesTypeTrendStackChart {
  VALUE = 'VALUE',
  VOLUME = 'VOLUME',
}
